/**
 * Deprecated
 */
export const INITIAITVE_SLIDEOVER_CLOSING_EVENT =
  'initiative-slideover-closing';
export const INITIAITVE_SLIDEOVER_SAVE = 'initiative-slideover-save';
